import React from 'react';
import './OurJourney.css';
import backgroundImage from '../assets/ourjourneybackground.png';
import redArrow from '../assets/redarrow.svg';
import videoPlayIcon from '../assets/video-play-icon.svg';
import greenOasisBg from '../assets/A4Acre-Green-Oasis-background-img.png';
import yogendraPortrait from '../assets/yogendra-founder-img.png';
import jyotiPortrait from '../assets/jyothi-founder-img.png';
import founderImage1 from '../assets/founder-image-1.png';
import founderImage2 from '../assets/founder-image-2.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../CampusandFacilities/Founders.css'
import journeyImg1 from '../assets/journeyImg1.png';
import journeyImg2 from '../assets/journeyImg2.png';
import journeyImg3 from '../assets/journeyImg3.png';
import journeyImg4 from '../assets/journeyImg4.png';
import journeyImg5 from '../assets/journeyImg5.png';
import journeyImg6 from '../assets/journeyImg6.png';
import journeyImg7 from '../assets/journeyImg7.png';
import journeyImg8 from '../assets/journeyImg8.png';

const OurJourney = () => {
    const settings = {
        dots: false,
        fade: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        pauseOnHover: false
    };
    return (
        <div className="our-journey-container">
            <div className='Leadershipbanner-bg'>
                <div className='wrapper'>
                    <div className="home-section-1-wrap">
                        <div className='home-section-1'>
                            <h3 class="our-journey-subtitle">Our Journey</h3>
                            <h1>Rooted In Values.<br />
                                Growing With Purpose.</h1>
                            <p>For over four decades, Sherwood Public School has been guided by strong values and belief in meaningful education. What began as a vision rooted in care and conviction continues to shape confident, thoughtful learners today.

                            </p>
                        </div>
                        <div className='home-section-2'>
                            {/* <img src={founderImage1} alt="" /> */}
                            <Slider {...settings}>
                                <div><img src={journeyImg1} alt="Sherwood Public School campus history Kompally Secunderabad" loading="eager" fetchPriority="high" /></div>
                                <div><img src={journeyImg2} alt="Founders of Sherwood Public School Secunderabad" loading="lazy" /></div>
                                <div><img src={journeyImg3} alt="Student activity area Sherwood Public School campus" loading="lazy" /></div>
                                <div><img src={journeyImg4} alt="About Sherwood Public School – Early Years & ICSE Education" loading="lazy" /></div>
                                <div><img src={journeyImg5} alt="Sherwood Public School cultural activities Hyderabad" loading="lazy" /></div>
                                <div><img src={journeyImg6} alt="Sherwood Public School sports day Kompally" loading="lazy" /></div>
                                <div><img src={journeyImg7} alt="Sherwood Public School campus Petbasheerabad" loading="lazy" /></div>
                                <div><img src={journeyImg8} alt="Journey of Sherwood Public School since 1984" loading="lazy" /></div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>


            {/* Our Journey Hero Section */}

            {/* Founders Section */}
            <div className="our-journey-founders-section">
                <div className="our-journey-founders-container">
                    {/* Left Container - Red Arrow & Video Box */}
                    <div className="our-journey-left-container">
                        <div className="our-journey-arrow-wrapper">
                            <img src={redArrow} alt="Decorative arrow" className="our-journey-red-arrow-icon" />
                        </div>
                        <div className="our-journey-video-box">
                            {window.navigator.userAgent !== 'ReactSnap' ? (
                                <iframe width="100%" height="415" src="https://www.youtube.com/embed/V7i-2Xmdjro?si=oKKDUvgzXnXlOZxb" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className='iframe-border'></iframe>
                            ) : (
                                <div style={{ width: '100%', height: '415px', backgroundColor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Video Loading...</div>
                            )}
                            {/* <img src={videoPlayIcon} alt="Play video" className="our-journey-video-play-icon" /> */}
                            {/* <span className="our-journey-video-placeholder-text">Video Placeholder</span> */}
                        </div>
                    </div>

                    {/* Right Container - Founders Content */}
                    <div className="our-journey-right-container">
                        <div className="our-journey-founders-content">
                            <h2 className="our-journey-founders-title">Founded by Passionate Educationists</h2>
                            <p className="our-journey-founders-description">
                                Late Mr. Yogendra K Gurwara and Mrs. Jyoti Gurwara founded Sherwood Public School on 21st June 1984  after years of experience in reputed schools across India. Guided by a deep belief in values-based, child-centered education, they established a school committed to all-round and meaningful learning.

                            </p>
                            <p className="our-journey-founders-description">
                                Over the years, Sherwood grew steadily as generations of parents placed their trust in its stress-free educational philosophy and the openness, integrity, and care that continue to define the school’s ethos.

                            </p>
                        </div>
                    </div>
                </div>
            </div>




            {/* Founders yogendra Profile Section */}
            <section className="founder-profile-section">
                <div className="founder-profile-container">
                    {/* Left Side - Portrait Image */}
                    <div className="founder-portrait-wrapper">
                        <div className="founder-portrait-frame">
                            <img
                                src={yogendraPortrait}
                                alt="Mr. Yogendra K Gurwara"
                                className="founder-portrait-image"
                            />
                        </div>
                    </div>

                    {/* Center - Vertical Divider */}
                    <div className="founder-divider"></div>

                    {/* Right Side - Text Content */}
                    <div className="founder-text-content">
                        <h2 className="founder-name">Late Mr. Yogendra K Gurwara
                        </h2>
                        <h3 className="founder-title">Founder-Director</h3>

                        <div className="founder-bio">
                            <p className="founder-bio-paragraph">
                                Yogendra K Gurwara was a distinguished educationist and visionary teacher who dedicated his life to nurturing young minds with compassion, discipline, and purpose. With teaching experience at institutions such as St. Paul’s School, Darjeeling, Sherwood College, Nainital, and Daly College, Indore, he brought together academic rigour and a deep understanding of child psychology.

                            </p>

                            <p className="founder-bio-paragraph">
                                A passionate advocate of experiential learning, Gurwara Sir believed that education extended far beyond classrooms and textbooks. He envisioned schools set in green, open spaces where children could learn freely, explore confidently, and grow naturally. This belief led to the founding of Sherwood Public School, Secunderabad in 1984, and Heritage Valley - The Indian School, Shadnagar in 2005.

                            </p>

                            <p className="founder-bio-paragraph">
                                An accomplished athlete and committed mentor, he led by example across academics, sports, co-curricular life, and outdoor learning experiences, instilling confidence, self-belief, and a strong sense of social responsibility in his students. His values-based approach laid the foundation for Sherwood’s enduring ethos and continues to guide the institution today.

                            </p> <p className="founder-bio-paragraph">He passed away in August 2025, leaving behind a lasting legacy reflected in the lives of thousands of students across the world who carry forward his ideals of learning, integrity, and service to society.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Founders jyoti Profile Section */}
            <section className="founder-profile-section">
                <div className="founder-profile-container">

                    {/* left Side - Text Content */}
                    <div className="founder-text-content">
                        <h2 className="founder-name">Mrs. Jyoti Gurwara
                        </h2>
                        <h3 className="founder-title">Co-Founder; Director
                        </h3>

                        <div className="founder-bio">
                            <p className="founder-bio-paragraph">Mrs. Jyoti Gurwara comes from a distinguished family of educationists and has devoted her life to nurturing meaningful relationships with teachers, students, and parents. Alongside her husband, she played a central role in shaping Sherwood’s open, positive, and student-focused culture.
                            </p>
                            <p className="founder-bio-paragraph">A trained librarian, compassionate teacher, and capable administrator, Mrs Gurwara has guided generations of students through stories drawn from Indian and world literature, encouraging reflection, curiosity, and emotional growth. She, along with Mr Gurwara,  served in some of the country’s most reputed public schools, bringing immense depth of experience and educational insight.
                            </p>
                            <p className="founder-bio-paragraph">With a strong grounding in music and dance, and as a melodious singer herself, she has led the school’s cultural life with sensitivity and purpose. Her NCC background and spirit of adventure have further enabled her to organise and participate in adventure camps, fostering confidence, discipline, and resilience in students.
                            </p>
                            <p className="founder-bio-paragraph">She is the daughter of the late Shri Krishna Dutt, Founder-Principal of Hindi Mahavidyalaya, Hyderabad, and the late Smt Kaushalya Dutt, Principal of Keshav Memorial Girls’ College, Hyderabad.</p>



                        </div>
                    </div>


                    {/* Center - Vertical Divider */}
                    <div className="founder-divider"></div>

                    {/* right Side - Portrait Image */}
                    <div className="founder-portrait-wrapper">
                        <div className="founder-portrait-frame">
                            <img
                                src={jyotiPortrait}
                                alt="Mr. Yogendra K Gurwara"
                                className="founder-portrait-image"
                            />
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
};

export default OurJourney;